import { Injectable, Injector } from '@angular/core';
import { RuntimeFrameworkService } from '../rtf-service';
import { IRuntimeFrameworkContext } from '@farris/devkit';
import { RuntimeFrameworkContext } from './types';

/**
 * è¿è¡æ¡æ¶ä¸ä¸ææå¡
 */
@Injectable()
export class RuntimeFrameworkContextService {
  public runtimeFrameworkContext: IRuntimeFrameworkContext = null;
  constructor(private injector: Injector, private frameworkService: RuntimeFrameworkService) {
    if (this.frameworkService) {
      const userInfo = this.frameworkService.userInfo;
      this.runtimeFrameworkContext = new RuntimeFrameworkContext(userInfo);
    }
  }
  /**
   * å½åç¨æ·id
   */
  public get userId() {
    return this.runtimeFrameworkContext && this.runtimeFrameworkContext.userId;
  }
  /**
   * å½åç¨æ·code
   */
  public get userCode() {
    return this.runtimeFrameworkContext && this.runtimeFrameworkContext.userCode;
  }
  /**
   * å½åç¨æ·name
   */
  public get userName() {
    return this.runtimeFrameworkContext && this.runtimeFrameworkContext.userName;
  }
  /**
   * æå±ç»ç»id
   */
  public get orgId() {
    return this.runtimeFrameworkContext && this.runtimeFrameworkContext.orgId;
  }
  /**
   * æå±ç»ç»åç§°
   */
  public get orgName() {
    return this.runtimeFrameworkContext && this.runtimeFrameworkContext.orgName;
  }
  /**
   * åä½id
   */
  public get unitId() {
    return this.runtimeFrameworkContext && this.runtimeFrameworkContext.unitId;
  }
  /**
   * åä½åç§°
   */
  public get unitName() {
    return this.runtimeFrameworkContext && this.runtimeFrameworkContext.unitName;
  }
}
